import React from "react"
import {FieldFormElementViewProps} from "../../../render/form-elemnent-view"
import FieldRating_InlineEditableStatefull from "../components/inline-edit/rating-component"

export default function FieldRating_FormElementView(props: FieldFormElementViewProps) {

    const value = props.field.getViewValue(props.model)

    return <FieldRating_InlineEditableStatefull className    = {props.className}
                                                field        = {props.field}
                                                value        = {value}
                                                disabled     = {props.disabled}
                                                onChange     = {props.onChange}/>
}